import React from 'react';
import './App.css';
import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react';
import Tabs from './components/Tabs';
import CopyrightFooter from './components/CopyrightFooter';
import LogoComponent from './components/LogoComponent';
import { Button } from '@mui/material';
import '@aws-amplify/ui-react/styles.css';
import '././components/Authenticator/styles.css';

const updatedConfig = {
  ...config,
  Auth: {
    ...config.Auth,
    oauth: {
      domain: 'https://zirkle.auth.us-west-2.amazoncognito.com',
      scope: ['openid', 'email', 'profile'],
      redirectSignIn: 'http://localhost:3000',
      redirectSignOut: 'http://localhost:3000',
      responseType: 'code'
    }
  }
};

Amplify.configure(updatedConfig);

function App() {

  return (
      <div className="App">
        <header className="App-header">
          <div className="image-container">
            <LogoComponent />
          </div>
          <div className="authenticator">
          <Authenticator>
          {({ signOut, user }) => (
            <main>
              <Button variant='contained' style={{
                backgroundColor: "#00531A",
                marginBottom: "12px"
              }} onClick={signOut}>Sign Out
              </Button>
                {/* <Dashboards clientName={"Zirkle"} /> */}
            </main>
          )}
        </Authenticator>
        </div>
        </header>
        <div className="timeLossTable">
        <Tabs />
        </div>
        <CopyrightFooter />
      </div>

  );
}

export default withAuthenticator(App);

